import React, { Component } from "react";
import { components } from "react-select";
import { Modal, Form, Col, Button, Card, Container, Row } from "react-bootstrap";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import moment, { invalid } from "moment";
import DateTime from 'react-datetime'
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { log } from "logrocket";
import { withApollo } from "react-apollo";
import CardLessDataTableWithOutSearch from '../datatables/CardLessDataTableWithOutSearch';
import { ToastContainer, toast } from "react-toastify";


const SEND_NOTIFICATION = gql`
  mutation($params: EducationNotifications) {
    sendEduNotification(params: $params)
  }`

class AttendanceNotificationModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loadingSpinner: 0,
            currentStep: 1,
            submitError: ""
        }
    }

    handleFormSubmit = async () => {
        let params = {
            date: moment(this.props.stateData.date, 'YYYY-MM-DD').unix().toString(),
            template_name: "Daily Attendance Status",
            branch_id: this.props.stateData.branchSearchval.value.toString(),
            institute_id: parseInt(Cookies.get("institutionid")),
            notification_type: "attendance",
            section_id: parseInt(this.props.stateData.sectionSearchval.value),
            attendance_subtype_id: parseInt(this.props.stateData.attendanceSearchval.value)
        }

        this.setState({ loadingSpinner: 1 })

        this.sendEduNotification(params).catch(error => {
            this.setState({ submitError: error.graphQLErrors.map(x => x.message), loadingSpinner: 0 })
            setTimeout(() => {
                this.props.onHide();
            }, 3000);
        })
    }

    sendEduNotification = async params => {

        await this.props.sendEduNotification({
            variables: {
                params
            },
            update: (store, { data }) => {
                if (data.sendEduNotification) {
                    this.setState({
                        loadingSpinner: 0,
                        currentStep: 5,
                    });
                    setTimeout(() => {
                        this.SetpageLoad();
                    }, 1500);
                }
            }
        });
    };

    SetpageLoad = () => {
        this.setState({ currentStep: 1, submitError: "" });
        this.props.onHide();
        this.props.history.push("/student/attendance-report");
    };

    Columns(data) {
        let Columns = [
            {
                dataField: "student_name",
                text: "Student name",
            },
            {
                dataField: "parent_mobile",
                text: "Parent mobile",
            }
        ];
        return Columns;
    }

    render() {
        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="example-modal-sizes-title-lg"
            >
                <Modal.Header
                    closeButton
                    style={{
                        background:
                            "linear-gradient(135deg, rgb(99, 102, 241), rgb(139, 92, 246))",
                        color: "#fff",
                        borderBottom: "none"
                    }}
                >
                    <Modal.Title
                        className="text-center"
                        style={{
                            width: "100%",
                            fontWeight: "700"
                        }}
                    >
                        Absent Notification
                    </Modal.Title>
                </Modal.Header>
                {
                    this.props.stateData.notifyLoader == 1 ?
                        (
                            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "50vh", width: "100%" }}>
                                <div className="spinner-border text-primary" role="status" style={{ width: "3rem", height: "3rem" }}>
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        )
                        :
                        (
                            <>
                                {
                                    this.props.stateData.getAbsentStudentsData.length > 0 ?
                                        (
                                            <>
                                                <Modal.Body className="p-1">
                                                    <CardLessDataTableWithOutSearch
                                                        parentData={this.props.stateData.getAbsentStudentsData}
                                                        particlecolumns={this.Columns()}
                                                    />
                                                </Modal.Body>

                                                <Modal.Footer variant="white" className="notify_footer">

                                                    <Row>
                                                        <Col sm={12}>
                                                            {this.state.currentStep == 5 ? (
                                                                <Form.Text className="form-text text-danger mb-2 " style={{ textAlign: "center" }}>
                                                                    Notification sent successfully
                                                                </Form.Text>
                                                            ) : (
                                                                <Form.Text className="form-text text-danger mb-2" style={{ textAlign: "center", display: "none" }}>
                                                                    {this.state.submitError}
                                                                </Form.Text>
                                                            )}
                                                        </Col>
                                                    </Row>
                                                    <Row>

                                                        <Col sm={12}>

                                                            <Button onClick={(e) => this.handleFormSubmit()} style={{ backgroundColor: "#213046", border: "1px solid #213046" }} type="submit" inline>
                                                                {
                                                                    this.state.loadingSpinner == 1 ? (
                                                                        <span className="spinner-border spinner-border-sm"></span>
                                                                    ) : ""
                                                                }
                                                                SEND</Button>
                                                        </Col>

                                                    </Row>
                                                </Modal.Footer>
                                            </>
                                        )
                                        :
                                        (
                                            <h6 className="text-center p-3">No students were absent</h6>
                                        )

                                }

                            </>
                        )
                }
            </Modal>

            // <Modal
            //     {...this.props}
            //     size="lg"
            //     centered
            //     className="notify_modal"
            // >
            //     <Modal.Body
            //         style={{
            //             padding: "0",
            //             borderRadius: "22px",
            //             overflow: "auto",
            //             background: "#f8fafc",
            //             height: "85vh",
            //             maxHeight: "85vh"
            //         }}
            //     >


            //         {/* Header */}
            //         <div
            //             style={{
            //                 background: "linear-gradient(135deg, #dc2626, #ef4444)",
            //                 padding: "28px 25px",
            //                 textAlign: "center",
            //                 color: "#fff",
            //                 position: "relative"
            //             }}
            //         >

            //             <button
            //                 onClick={this.props.onHide}
            //                 style={{
            //                     position: "absolute",
            //                     top: "15px",
            //                     right: "15px",
            //                     border: "none",
            //                     background: "rgba(255,255,255,0.18)",
            //                     color: "#fff",
            //                     width: "34px",
            //                     height: "34px",
            //                     borderRadius: "50%",
            //                     cursor: "pointer",
            //                     fontSize: "16px"
            //                 }}
            //             >
            //                 ✕
            //             </button>

            //             <div
            //                 style={{
            //                     width: "75px",
            //                     height: "75px",
            //                     borderRadius: "50%",
            //                     background: "rgba(255,255,255,0.18)",
            //                     display: "flex",
            //                     alignItems: "center",
            //                     justifyContent: "center",
            //                     margin: "0 auto 15px auto",
            //                     fontSize: "32px"
            //                 }}
            //             >
            //                 <i className="fa fa-bell"></i>
            //             </div>

            //             <h3
            //                 style={{
            //                     marginBottom: "6px",
            //                     fontWeight: "700"
            //                 }}
            //             >
            //                 Absent Notification
            //             </h3>

            //             <p
            //                 style={{
            //                     marginBottom: 0,
            //                     opacity: 0.92,
            //                     fontSize: "14px"
            //                 }}
            //             >
            //                 Send notifications to absent students' parents
            //             </p>

            //         </div>

            //         {/* Body */}
            //         <div style={{ padding: "22px" }}>

            //             {
            //                 this.props.stateData.notifyLoader == 1 ? (
            //                     <Container>
            //                         <Row>
            //                             <Col sm={12}>
            //                                 <div
            //                                     className="d-flex flex-column justify-content-center align-items-center"
            //                                     style={{
            //                                         minHeight: "250px"
            //                                     }}
            //                                 >

            //                                     <div
            //                                         className="spinner-border"
            //                                         style={{
            //                                             width: "3.5rem",
            //                                             height: "3.5rem",
            //                                             color: "#ef4444"
            //                                         }}
            //                                     ></div>

            //                                     <h6
            //                                         style={{
            //                                             marginTop: "18px",
            //                                             color: "#6b7280",
            //                                             fontWeight: "600"
            //                                         }}
            //                                     >
            //                                         Loading absent students...
            //                                     </h6>

            //                                 </div>
            //                             </Col>
            //                         </Row>
            //                     </Container>
            //                 ) : (
            //                     <>
            //                         {
            //                             this.props.stateData.getAbsentStudentsData.length > 0 ? (
            //                                 <>

            //                                     {/* Stats Card */}
            //                                     <Row className="mb-4">
            //                                         <Col sm={12}>
            //                                             <div
            //                                                 style={{
            //                                                     background: "linear-gradient(135deg, #fff1f2, #ffe4e6)",
            //                                                     border: "1px solid #fecdd3",
            //                                                     borderRadius: "16px",
            //                                                     padding: "18px",
            //                                                     display: "flex",
            //                                                     alignItems: "center",
            //                                                     justifyContent: "space-between",
            //                                                     flexWrap: "wrap",
            //                                                     gap: "15px"
            //                                                 }}
            //                                             >
            //                                                 <div className="d-flex align-items-center">
            //                                                     <div
            //                                                         style={{
            //                                                             width: "55px",
            //                                                             height: "55px",
            //                                                             borderRadius: "50%",
            //                                                             background: "#ef4444",
            //                                                             color: "#fff",
            //                                                             display: "flex",
            //                                                             alignItems: "center",
            //                                                             justifyContent: "center",
            //                                                             fontSize: "24px",
            //                                                             marginRight: "14px"
            //                                                         }}
            //                                                     >
            //                                                         <i className="fa fa-user-times"></i>
            //                                                     </div>

            //                                                     <div>
            //                                                         <h5
            //                                                             style={{
            //                                                                 marginBottom: "4px",
            //                                                                 fontWeight: "700",
            //                                                                 color: "#991b1b"
            //                                                             }}
            //                                                         >
            //                                                             Absent Students
            //                                                         </h5>

            //                                                         <p
            //                                                             style={{
            //                                                                 marginBottom: 0,
            //                                                                 color: "#7f1d1d",
            //                                                                 fontSize: "14px"
            //                                                             }}
            //                                                         >
            //                                                             {
            //                                                                 this.props.stateData.getAbsentStudentsData.length
            //                                                             } students will receive notifications
            //                                                         </p>
            //                                                     </div>
            //                                                 </div>
            //                                             </div>
            //                                         </Col>
            //                                     </Row>

            //                                     {/* Table */}
            //                                     <div
            //                                         style={{
            //                                             background: "#fff",
            //                                             borderRadius: "18px",
            //                                             padding: "15px",
            //                                             boxShadow: "0 6px 20px rgba(0,0,0,0.06)",
            //                                             overflowX: "auto"
            //                                         }}
            //                                     >
            //                                         <CardLessDataTableWithOutSearch
            //                                             parentData={
            //                                                 this.props.stateData.getAbsentStudentsData
            //                                             }
            //                                             particlecolumns={this.Columns()}
            //                                         />
            //                                     </div>

            //                                     {/* Success/Error */}
            //                                     <div className="text-center mt-4">

            //                                         {
            //                                             this.state.currentStep == 5 ? (
            //                                                 <p
            //                                                     style={{
            //                                                         color: "#16a34a",
            //                                                         fontWeight: "600",
            //                                                         marginBottom: "10px"
            //                                                     }}
            //                                                 >
            //                                                     Notification sent successfully
            //                                                 </p>
            //                                             ) : (
            //                                                 <p
            //                                                     style={{
            //                                                         color: "#ef4444",
            //                                                         fontWeight: "500",
            //                                                         marginBottom: "10px"
            //                                                     }}
            //                                                 >
            //                                                     {this.state.submitError}
            //                                                 </p>
            //                                             )
            //                                         }

            //                                     </div>

            //                                     {/* Button */}
            //                                     <div className="text-center mt-3">
            //                                         <Button
            //                                             onClick={(e) => this.handleFormSubmit()}
            //                                             type="submit"
            //                                             style={{
            //                                                 background:
            //                                                     "linear-gradient(135deg, #dc2626, #ef4444)",
            //                                                 border: "none",
            //                                                 borderRadius: "14px",
            //                                                 padding: "12px 30px",
            //                                                 fontWeight: "700",
            //                                                 fontSize: "15px",
            //                                                 boxShadow:
            //                                                     "0 8px 20px rgba(239,68,68,0.35)",
            //                                                 minWidth: "220px"
            //                                             }}
            //                                         >
            //                                             {
            //                                                 this.state.loadingSpinner == 1 ? (
            //                                                     <span className="spinner-border spinner-border-sm mr-2"></span>
            //                                                 ) : (
            //                                                     <i className="fa fa-paper-plane mr-2"></i>
            //                                                 )
            //                                             }

            //                                             Send Notification
            //                                         </Button>
            //                                     </div>

            //                                 </>
            //                             ) : (
            //                                 <div
            //                                     className="d-flex flex-column justify-content-center align-items-center"
            //                                     style={{
            //                                         minHeight: "280px"
            //                                     }}
            //                                 >

            //                                     <div
            //                                         style={{
            //                                             width: "90px",
            //                                             height: "90px",
            //                                             borderRadius: "50%",
            //                                             background: "#f0fdf4",
            //                                             color: "#16a34a",
            //                                             display: "flex",
            //                                             alignItems: "center",
            //                                             justifyContent: "center",
            //                                             fontSize: "42px",
            //                                             marginBottom: "18px"
            //                                         }}
            //                                     >
            //                                         <i className="fa fa-check-circle"></i>
            //                                     </div>

            //                                     <h4
            //                                         style={{
            //                                             color: "#166534",
            //                                             fontWeight: "700",
            //                                             marginBottom: "8px"
            //                                         }}
            //                                     >
            //                                         Perfect Attendance
            //                                     </h4>

            //                                     <p
            //                                         style={{
            //                                             color: "#6b7280",
            //                                             fontSize: "15px",
            //                                             marginBottom: 0
            //                                         }}
            //                                     >
            //                                         No students were absent today
            //                                     </p>

            //                                 </div>
            //                             )
            //                         }
            //                     </>
            //                 )
            //             }

            //         </div>
            //         <ToastContainer />
            //     </Modal.Body>
            // </Modal>
        )
    }
}


export default withRouter(withApollo(compose(
    graphql(SEND_NOTIFICATION, {
        name: "sendEduNotification"
    })
)(AttendanceNotificationModal)));